<div style="display:flex; flex-direction:row; flex-grow:1; overflow:hidden;">
    <div style="display:flex; flex-direction:column; flex:1; overflow:hidden;">
        <tyl-kendo-pdf-export [keepTogether]="'.mat-row'" class="tylKendoPdf">
            <div class="flex-header">
                <student-header [showYearSelector]="true" [pageTitle]="'Assignments'"></student-header>
            </div>
            <div class="flex-content">
                <tabs [startingIndex]="getSelectedTabIndex()" [tabNames]="tabNames" (tabChange)="tabChange($event)"></tabs>
                <div>
                    <by-course #byCourse [shown]="ShowByClass" (schoolYearSettingsChange)="schoolYearSettingsChange($event)"></by-course>
                    <upcoming-missing #upcomingMissing [shown]="!ShowByClass" (missingRetrieved)="missingRetrieved()">
                    </upcoming-missing>
                </div>
            </div>
        </tyl-kendo-pdf-export>

        <!-- Footer -->
        <div class="flex-footer">
            <div class="flex-footer-left">
                <expand-collapse-buttons [expandEmitter]="toggleAllRows" style="padding-left: 10px;">
                </expand-collapse-buttons>
                <tyl-button image="filter.png" label="Filter" (clickEvent)="showFilterClick();" *ngIf="!showFilter">
                </tyl-button>
                <tyl-button image="filter yellow.png" label="Filter" (clickEvent)="showFilterClick();"
                    *ngIf="showFilter"></tyl-button>
                <tyl-button id="btnLegend" image="Legend.png" label="Legend" (clickEvent)="legendClick()" *ngIf="showLegends()"></tyl-button>
            </div>
            <div class="footerCenter" style="align-items: center">
                <filter-notification (clearFilter)="clearFilterClick()" (filter)="showFilterClick();"
                    [filtered]="isFiltered || (!ShowByClass && upcomingMissing.angularMatData && upcomingMissing.angularMatData.isFiltered()) || (ShowByClass && byCourse.angularMatData.isFiltered())">
                </filter-notification>
            </div>
            <div class="flex-footer-right">
            </div>
        </div>

    </div>

    <assignment-filter #assignmentFilter [ShowByClass]="ShowByClass"
        [ngStyle]="{'display': showFilter ? 'flex': 'none'}" (clearFilterEvent)="clearFilterClick"
        (filterChange)="filterChange()" (filterClose)="showFilterClick();"
        class="filter-body" [schoolYearSettings]="schoolYearSettings">
    </assignment-filter>

</div>